<template>
  <div :class="'uploader '+classNames">
    <div class="display">
      <p>✔<br>Drag and drop, or click to upload</p>
    </div>
    <input type="file" accept="image/*" @change="detectFiles($event.target.files)">
    <div v-if="uploading" class="progress-bar"> 
      <div class="loader" />
      <div class="progress-bar__text">{{ progressUpload }}%</div>
      <div class="progress-bar__inner" :style="{ width: progressUpload + '%'}"></div>
    </div>
  </div>
</template>

<script>
  import firebase from 'firebase'
  export default {
    name: 'file-uploader',
    props: ['classNames', 'objectName'],
    data () {
      return {
        progressUpload: 0,
        file: File,
        uploadTask: '',
        downloadURL: '',
        uploading: false
      }
    },
    methods: {
      detectFiles (fileList) {
        let files = Array.from(Array(fileList.length).keys())
        Promise.all(files.map( x => this.upload(fileList[x]) ))
          .then((url) => { this.uploading = false })
      },
      upload (file) {
        this.uploading = true
        console.log(this, this.$options.propsData)
        return firebase.storage().ref('uploads').child(`${+(new Date())}-${file.name}`).put(file)
          .then(snapshot => { this.$emit('url', snapshot.downloadURL, this.$options.propsData) })
      }
    },
    watch: {
      uploadTask: function() {
        this.uploadTask.on('state_changed', sp => {
          this.progressUpload = sp.bytesTransferred / sp.totalBytes * 100
        })
      }
    }
  }
</script>

<style scoped>
  .uploader {
    align-items: center;
    background: #ccc;
    box-sizing: border-box;
    display: flex;
    font-family: 'courier new', monospace;
    font-size: 90%;
    justify-content: center;
    line-height: 1.4;
    max-height: 10rem !important;
    max-width: 10rem !important;
    overflow: hidden;
    padding: 2rem;
    position: relative;
    text-align: center;
  }
  .uploader:hover {
    background: #06c;
    color: #fff;
  }
  .uploader--wide {
    max-width: 100% !important;
  }
  .uploader input {
    cursor: pointer;
    font-size: 900%;
    height: 100%;
    left: 0;
    opacity: 0;
    position: absolute;
    top: 0;
  }
  .progress-bar {
    align-items: center;
    color: #fff;
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    background-color: #ddd;
    z-index: 1;
  }
  .progress-bar__inner {
    background: #06c;
    left: 0;
    position: absolute;
    top: 0;
    width: 56%;
    height: 100%;
  }
  .progress-bar__text {
    color: #fff;
    mix-blend-mode: difference;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
    font-size: 75%;
    opacity: 0;
  }

  .loader,
  .loader:after {
    border-radius: 50%;
    width: 4em;
    height: 4em;
  }
  .loader {
    margin: 60px auto;
    font-size: 10px;
    position: relative;
    text-indent: -9999em;
    border-top: 0.75em solid rgba(0, 0, 0, 0.2);
    border-right: 0.75em solid rgba(0, 0, 0, 0.2);
    border-bottom: 0.75em solid rgba(0, 0, 0, 0.2);
    border-left: 0.75em solid #333;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-animation: load8 800ms infinite linear;
    animation: load8 800ms infinite linear;
  }
  @-webkit-keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(350deg);
      transform: rotate(350deg);
    }
  }
  @keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/FileUploader.vue